import { render } from "./Direct_Sales.vue?vue&type=template&id=26de8134&scoped=true"
import script from "./Direct_Sales.vue?vue&type=script&lang=js"
export * from "./Direct_Sales.vue?vue&type=script&lang=js"

import "./Direct_Sales.vue?vue&type=style&index=0&id=26de8134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26de8134"]])

export default __exports__